export const TOKEN_TYPE = 'Bearer ';
export const REQUEST_HEADER_AUTH_KEY = 'Authorization';
export const REQUEST_HEADER_CONTENT_TYPE = 'Content-Type';
export const API_URL = process.env.REACT_APP_API_HOST;
export const UPLOAD_SIZE = process.env.REACT_APP_MAX_UPLOAD_SIZE ?? 15;
